// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Button from "../components/Button/Button.bs.js";
import * as Emotion from "../bindings/Emotion.bs.js";
import * as Skeleton from "../components/Skeleton/Skeleton.bs.js";
import * as PostTeaser from "../components/PostTeaser/PostTeaser.bs.js";
import * as Typography from "../components/Typography/Typography.bs.js";
import * as AuthContext from "../context/AuthContext.bs.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as RescriptReactRouter from "@rescript/react/src/RescriptReactRouter.bs.js";
import * as RescriptRelay_Query from "rescript-relay/src/RescriptRelay_Query.bs.js";
import * as HomePageQuery_graphql from "../__generated__/HomePageQuery_graphql.bs.js";
import * as RescriptReactErrorBoundary from "@rescript/react/src/RescriptReactErrorBoundary.bs.js";

let convertVariables = HomePageQuery_graphql.Internal.convertVariables;

let convertResponse = HomePageQuery_graphql.Internal.convertResponse;

let convertWrapRawResponse = HomePageQuery_graphql.Internal.convertWrapRawResponse;

let use = RescriptRelay_Query.useQuery(convertVariables, HomePageQuery_graphql.node, convertResponse);

let useLoader = RescriptRelay_Query.useLoader(convertVariables, HomePageQuery_graphql.node, prim => prim);

let usePreloaded = RescriptRelay_Query.usePreloaded(HomePageQuery_graphql.node, convertResponse, prim => prim);

let fetch = RescriptRelay_Query.fetch_(HomePageQuery_graphql.node, convertResponse, convertVariables);

let fetchPromised = RescriptRelay_Query.fetchPromised(HomePageQuery_graphql.node, convertResponse, convertVariables);

let retain = RescriptRelay_Query.retain(HomePageQuery_graphql.node, convertVariables);

let PostsQuery = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  use: use,
  useLoader: useLoader,
  usePreloaded: usePreloaded,
  fetch: fetch,
  fetchPromised: fetchPromised,
  retain: retain
};

function HomePage$Latest(props) {
  let data = use(undefined, undefined, undefined, undefined);
  let auth = AuthContext.useAuth();
  let rest = data.posts.slice(1);
  let match = auth.state;
  let writePath;
  writePath = typeof match !== "object" ? "/login" : "/journal";
  let match$1 = auth.state;
  let writeLabel;
  writeLabel = typeof match$1 !== "object" ? "Sign in to write" : "Write in the journal";
  let featured = data.posts[0];
  return JsxRuntime.jsxs("div", {
    children: [
      featured !== undefined ? JsxRuntime.jsx(PostTeaser.PostTeaser.make, {
          id: featured.id,
          title: featured.title,
          body: featured.body,
          authorName: featured.author.name,
          createdAt: featured.createdAt,
          size: "featured"
        }) : JsxRuntime.jsx(Typography.Typography.Body.make, {
          className: Emotion.Css.css({
            color: Emotion.Utils.Color.textSecondary
          }),
          children: "No entries yet. The desk is empty."
        }),
      rest.length !== 0 ? JsxRuntime.jsx(Typography.Typography.Overline.make, {
          className: Emotion.Css.css({
            marginBottom: "1.5rem",
            display: "block"
          }),
          children: "Recent writing"
        }) : null,
      rest.map(post => JsxRuntime.jsx(PostTeaser.PostTeaser.make, {
        id: post.id,
        title: post.title,
        body: post.body,
        authorName: post.author.name,
        createdAt: post.createdAt
      }, post.id)),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx(Button.Button.make, {
            variant: "outline",
            onClick: param => RescriptReactRouter.push("/posts"),
            children: "All posts"
          }),
          JsxRuntime.jsx(Button.Button.make, {
            variant: "ghost",
            onClick: param => RescriptReactRouter.push(writePath),
            children: writeLabel
          })
        ],
        className: Emotion.Css.css({
          display: "flex",
          flexWrap: "wrap",
          gap: "0.75rem",
          marginTop: "0.5rem"
        })
      })
    ]
  });
}

let Latest = {
  make: HomePage$Latest
};

function HomePage(props) {
  let containerStyles = Emotion.Css.css({
    padding: "4rem 1rem 5rem",
    maxWidth: "680px",
    margin: "0 auto"
  });
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx(Typography.Typography.Overline.make, {
        children: "The Journal"
      }),
      JsxRuntime.jsx(Typography.Typography.Display.make, {
        size: "4xl",
        className: Emotion.Css.css({
          marginTop: "1rem"
        }),
        children: "Notes in the open. Writing at the desk."
      }),
      JsxRuntime.jsx(Typography.Typography.Body.make, {
        className: Emotion.Css.css({
          color: Emotion.Utils.Color.textSecondary,
          fontStyle: "italic",
          margin: "1.5rem 0 3rem"
        }),
        children: "Read the catalog without signing in. Open a full entry. Sit down to write when you have something to keep."
      }),
      JsxRuntime.jsx(RescriptReactErrorBoundary.make, {
        children: JsxRuntime.jsx(React.Suspense, {
          children: JsxRuntime.jsx(HomePage$Latest, {}),
          fallback: JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx(Skeleton.Skeleton.make, {
                variant: "title"
              }),
              JsxRuntime.jsx(Skeleton.Skeleton.Stack.make, {
                count: 3
              })
            ],
            className: Emotion.Css.css({
              display: "flex",
              flexDirection: "column",
              gap: "1.5rem"
            })
          })
        }),
        fallback: param => JsxRuntime.jsx(Typography.Typography.Body.make, {
          className: Emotion.Css.css({
            color: Emotion.Utils.Color.textSecondary
          }),
          children: "The catalog could not load."
        })
      })
    ],
    className: containerStyles
  });
}

let Typography$1;

let Button$1;

let Skeleton$1;

let PostTeaser$1;

let make = HomePage;

export {
  PostsQuery,
  Typography$1 as Typography,
  Button$1 as Button,
  Skeleton$1 as Skeleton,
  PostTeaser$1 as PostTeaser,
  Latest,
  make,
}
/* use Not a pure module */
